










































































































































































import FlightPassengerList from "@/store/entities/flight/flightPassengerList";
import FlightReservationOrder from "@/store/entities/flight/reservation/flightReservationOrder";
import { PropType } from "vue";
import { Component, Vue, Prop, Emit, Watch } from "vue-property-decorator";
import ReservationDetailModal from "../views/pages/flight/modals/reservationDetailModal.vue";
@Component({
  components: { ReservationDetailModal },
})
export default class CustomTable extends Vue {
  @Prop({ type: Array as PropType<FlightPassengerList[]> })
  flightPassenger!: FlightPassengerList[];
  name: string = "CustomTable";
  headers: any[] = [];
  isCheckAll: boolean = false;
  isCheckAllOrder:boolean=false;
  checkedPassengers: FlightReservationOrder[] = [];
  isOpenModal:boolean=false;
selectedCount:number=0;
totalPassengerCount =0;
  checkAllOrder() {
   
      if(this.isCheckAllOrder){

        this.checkedPassengers=[];
      
        for (let item of this.flightPassenger) {
          item.flightOrders.forEach(element => {
         
            this.checkedPassengers.push(element);
            this.checkedPassengers.forEach(element => {
              element.isChecked=true;
            });
              });
        }
      }
      else{
        this.checkedPassengers.forEach(element => {
              element.isChecked=false;
            });
            this.checkedPassengers=[];
      }

   

     
   
    
  }
  changePassenger(passenger, index) {
  if (passenger.isChecked) {
    // Checkbox seçildiyse ekleyin
    let orderNo = passenger.orderNo;
    var passengers = this.flightPassenger[index].flightOrders.filter(x => x.orderNo == orderNo);
    passengers.forEach(element => {
      element.isChecked=true;
      this.checkedPassengers.push(element);
    });
  } else {
    // Checkbox seçimi kalktıysa kaldırın
    let orderNo = passenger.orderNo;
    var passengers = this.flightPassenger[index].flightOrders.filter(x => x.orderNo == orderNo);
    passengers.forEach(element => {
      element.isChecked=false;
    });
    this.checkedPassengers = this.checkedPassengers.filter(element => element.orderNo !== orderNo);
  }
}
  created() {
     this.flightPassenger.forEach(element => {
      
        var item= element.flightOrders;
        item.forEach(pass => {
          if(pass.isChecked){
            this.checkedPassengers.push(pass)
          }
  
        });
     
     });
 

    this.headers = [
      { text: "PNR", value: "pnr" },
      { text: "Güzergah", value: "destination" },
      { text: "Uçuş Numarası", value: "flightNo" },
      { text: "Acente", value: "agency" },
      { text: "Operatör", value: "code" },
      { text: "Soyadı", value: "surname" },
      { text: "İsim", value: "name" },
      { text: "Cinsiyet", value: "gender" },
    ];
    
  }
  async openReservationDetail(item){
  
    await this.$store.dispatch({
      type: "reservation/getFlightOrders",
      data: item.orderId,
    });
    this.isOpenModal=true;
  }
  closeModal() {
  
  this.isOpenModal = false;
  
}
  checkAll(index) {
 
    if(this.flightPassenger[index].isChecked){
      
      for (let item of this.flightPassenger[index].flightOrders) {
        if(!item.isChecked){
          item.isChecked=true;
        this.checkedPassengers.push(item);
        }
  
       
       
    
      }

    }
    else{
      for (let item of this.flightPassenger[index].flightOrders) {
      this.checkedPassengers = this.checkedPassengers.filter(element => element.orderNo !== item.orderNo);
      item.isChecked = false; // Uçuş siparişini işareti kaldır
    }
    }
  }
 
  
 
  @Watch("checkedPassengers")
  onChangePassengerCheckedList() {
      

    this.$store.commit({
      type: "flightPassengers/setCheckedPassengerList",
      data: this.checkedPassengers,
    });
 
    this.$emit("checked-selected",this.checkedPassengers.length);
  }
}

